import type { CurrentUser } from './use-current-user';

/**
 * The single source of truth for permission checks in web-admin: reads the
 * resolved `permissions` `GET /auth/me` returns, never a role→permission
 * mirror. `currentUser` is `undefined` while the profile is still loading,
 * which this treats as "no permission" so nothing permission-gated flashes
 * open before the real answer arrives.
 */
export function hasPermission(currentUser: CurrentUser | undefined, code: string): boolean {
  return currentUser?.permissions?.includes(code) ?? false;
}
